const PREK_GRADE_LABELS = new Set(["PreK 1", "PreK 2", "PreK 3"]);

function isPreKGradeLabel(label: string): boolean {
  if (PREK_GRADE_LABELS.has(label)) {
    return true;
  }

  const lower = label.toLowerCase();
  return lower.startsWith("prek") || lower.startsWith("pre-k") || lower.startsWith("pre-kindergarten");
}

/**
 * Maps a grade_levels label to its Find My School display label.
 * PreK grades are shown as "PS"; grade 13 is not displayed.
 */
export function formatFindMySchoolGradeLabel(label: string | null): string | null {
  if (!label) {
    return null;
  }

  const trimmed = label.trim();
  if (!trimmed) {
    return null;
  }

  if (isPreKGradeLabel(trimmed)) {
    return "PS";
  }

  if (trimmed === "13") {
    return null;
  }

  return trimmed;
}

/**
 * Formats the served grade range for Find My School school cards.
 */
export function formatFindMySchoolGradeRange(
  lowest: string | null,
  highest: string | null,
): string | null {
  const low = formatFindMySchoolGradeLabel(lowest);
  const high = formatFindMySchoolGradeLabel(highest);

  if (!low || !high) {
    return null;
  }

  if (low === high) {
    return `${low} Grades`;
  }

  return `${low} – ${high} Grades`;
}
